<template>
    <c-header-nav class="align-items-center gap-3">
        <slot />
    </c-header-nav>
</template>
<script setup>
import { CHeaderNav } from '@coreui/vue/dist/esm/components/header/index.js';
</script>
